import axios from 'axios'
import { ironsightAxios } from '@/api/base'
import { ResourcesGeoJSONQuery } from '@ironsight/types'
import qs from 'qs'

interface Feature {
  id: string
  type: 'Feature'
  geometry: {
    type: 'Point'
    coordinates: [number, number]
  }
  properties: {
    Name: string
    Status: string
    ResourceTypeId: number
    OwnerId: string
    DivisionName: string
    OrganizationName: string
    LastLocationHeading: number | null
    LastLocationGPSUpdatedTime: string | null
    LastLocationUserSid: string | null
    OnDuty: boolean
    OperatorSid: string | null
    OperatorOccuredAt: string | null
  }
}

export interface FeatureCollection {
  type: 'FeatureCollection'
  features: Feature[]
}

export async function fetchResourcesGeoJSON(
  params: ResourcesGeoJSONQuery,
  signal?: AbortSignal
): Promise<FeatureCollection> {
  const url = '/api/v3/field-view/geojson/resources'

  if (params.ownerIds?.every((id) => id === null)) {
    return { type: 'FeatureCollection', features: [] }
  }

  const source = axios.CancelToken.source()
  signal?.addEventListener('abort', () => {
    source.cancel('Query was cancelled by TanStack Query')
  })

  // filter out null/undefined to avoid sending empty values
  const cleaned: Partial<ResourcesGeoJSONQuery> = {
    resourceTypeIds: params.resourceTypeIds?.filter(
      (id): id is number => id != null
    ),
    ownerIds: params.ownerIds?.filter((id) => id != null),
    divisionIds: params.divisionIds?.filter((id) => !!id),
  }

  return ironsightAxios
    .get<FeatureCollection>(url, {
      cancelToken: source.token,
      params: cleaned,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: 'repeat' }),
    })
    .then((res) => res.data)
}
